const theme = {
  breakpoints: {
    mobile: "480px",
    tablet: "768px",
    desktop: "1200px",
  },
};

export default theme;
